import React from "react";
import Percentile from "../percentile/Percentile";

const TableCellPercentile = ({ value = null, data_name = "" }) => {
  return (
    <td className="PercentileCell" data-name={data_name}>
      {typeof value === "string" ? <Percentile data={value} /> : null}
      {typeof value === "number" ? (
        value === null ? (
          "N/A"
        ) : (
          <Percentile data={Math.round(value * 100).toString()} />
        )
      ) : (
        "N/A"
      )}
    </td>
  );
};

export default TableCellPercentile;
